import { omit as _omit } from "lodash";

/**
 * lodash omit + proper typings
 */
export function omit<T extends Record<string, any>, K extends keyof T>(
  obj: T,
  ...keys: K[]
) {
  return _omit(obj, ...keys) as Omit<T, K>;
}
